import { render, staticRenderFns } from "./UploadImage.vue?vue&type=template&id=c8a27fa8&scoped=true"
import script from "./UploadImage.vue?vue&type=script&lang=js"
export * from "./UploadImage.vue?vue&type=script&lang=js"
import style0 from "./UploadImage.vue?vue&type=style&index=0&id=c8a27fa8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8a27fa8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c8a27fa8')) {
      api.createRecord('c8a27fa8', component.options)
    } else {
      api.reload('c8a27fa8', component.options)
    }
    module.hot.accept("./UploadImage.vue?vue&type=template&id=c8a27fa8&scoped=true", function () {
      api.rerender('c8a27fa8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hr/archives/src/UploadImage.vue"
export default component.exports